import { useMemo, useState } from "react";
import useRosterPrevTail, {
  type PrevTailData,
} from "@/hooks/roster-craete/useRosterPrevTail";
import type { CurDate } from "@/store/scheduleStore";

type UseRosterPrevTailPanelParams = {
  curDate: CurDate | null;
  scheduleId: string | undefined;
  groupId: string;
};

export function useRosterPrevTailPanel({
  curDate,
  scheduleId,
  groupId,
}: UseRosterPrevTailPanelParams) {
  const [isPrevMonthOpen, setIsPrevMonthOpen] = useState(false);

  const { data: prevTailData, isFetching: isFetchingPrevTail } =
    useRosterPrevTail({
      year: curDate?.year ?? 0,
      month: curDate?.month ?? 0,
      scheduleId,
      groupId,
      enabled: isPrevMonthOpen,
    });

  const effectivePrevTailData = useMemo<PrevTailData | null>(() => {
    if (!isPrevMonthOpen) return null;
    if (prevTailData?.nurses && prevTailData.nurses.length > 0) {
      return prevTailData;
    }

    const pMonth = curDate?.month === 1 ? 12 : (curDate?.month ?? 1) - 1;
    const pYear =
      curDate?.month === 1 ? (curDate?.year ?? 0) - 1 : (curDate?.year ?? 0);
    const prevMonthLastDay = new Date(pYear, pMonth, 0).getDate();
    const tail_days = Array.from(
      { length: 6 },
      (_, i) => prevMonthLastDay - 5 + i
    );

    return {
      nurses: [{ nurse_id: "dummy", name: "dummy", shifts: {} }],
      tail_days,
      prev_month: pMonth,
      prev_year: pYear,
    };
  }, [isPrevMonthOpen, prevTailData, curDate?.year, curDate?.month]);

  return {
    isPrevMonthOpen,
    setIsPrevMonthOpen,
    effectivePrevTailData,
    isFetchingPrevTail,
  };
}
